export class MenuNotification {
  operation: OperationType = OperationType.NONE;
  id: string | null = null;
  name: string = '';
  newName: string = '';
  result: any;
  isMachine: boolean = false;
  isTemplatePage: boolean = false;
  pageId: string = '';

  constructor(operation: OperationType, id: string | null, name: string, newName: string, isTemplate: boolean = false) {
    this.operation = operation;
    this.id = id;
    this.name = name;
    this.newName = newName;
    this.isTemplatePage = isTemplate;
  }
}

export enum OperationType {
  NONE,
  DELETE,
  DELETE_PAGE,
  ADD,
  UPDATE_NAME,
  UPDATE_BASE_MENU_ITEMS_ORDER,
  UPDATE_USER_MENU_ITEMS_ORDER,
  UPDATE_IN_MACHINES_LIST,
  UPDATE_INSIDE_PARENT,
  UPDATE_USER_MACHINERY_GROUP,
  SHARE_OR_UN_SHARE_PAGE,
  UPDATE
}
